// @flow

import gql from 'graphql-tag';

const appAlternativesOverviewQuery = gql`
  query appAlternativesOverviewQuery($slug: String!) {
    appBySlug(slug: $slug) {
      id
      slug
      name
      reviewPage {
        id
        similarApps {
          id
          slug
          name
          image
          categories {
            id
            name
          }
        }
      }
    }
  }
`;

export default appAlternativesOverviewQuery;
